import { Tag } from '@kcd/design-system';

import ColorTag from '~/components/ColorTag';
import { useCurrentUserPlusMembership } from '~/domains/auth/queries';

import MembershipIcon from '~/assets/icons/logo__none__membership__16x16.svg';
import MembershipStandardIcon from '~/assets/icons/logo__none__membership_standard__16x16.svg';

const CouponMembershipBadge = () => {
  const { data: membershipData } = useCurrentUserPlusMembership();
  const isMembershipStandard =
    membershipData?.planDetail?.planGrade === 'STANDARD';

  return (
    <>
      {isMembershipStandard ? (
        <Tag
          label="멤버십 전용"
          className="bg-bonuspackGreen-backgroundLight text-bonuspackGreen-text"
          left={<MembershipStandardIcon />}
        />
      ) : (
        <ColorTag label="멤버십 전용" color="blue" left={<MembershipIcon />} />
      )}
    </>
  );
};

export default CouponMembershipBadge;
